export class SettingType {
  id: number;
  name: string;
  setting_group_id: number;
  description: string;
}
